import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'label', 'dropdown', 'checkbox']
  static values = { placeholder: String }

  connect() {
    this.boundClose = this.closeOnClickOutside.bind(this)
    this.boundEscape = this.closeOnEscape.bind(this)

    document.addEventListener('click', this.boundClose)
    document.addEventListener('keydown', this.boundEscape)

    this.updateLabel()
  }

  disconnect() {
    document.removeEventListener('click', this.boundClose)
    document.removeEventListener('keydown', this.boundEscape)
  }

  toggle(event) {
    event.stopPropagation()

    this.dropdownTarget.classList.toggle('hidden')
  }

  close() {
    this.dropdownTarget.classList.add('hidden')
  }

  updateLabel() {
    const selected = this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.dataset.label)
    const hasSelection = selected.length > 0

    this.labelTarget.textContent = hasSelection ? selected.join(', ') : this.placeholderValue
    this.labelTarget.classList.toggle('text-outline/60', !hasSelection)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  closeOnEscape(event) {
    if (event.key === 'Escape') this.close()
  }
}
